import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './ThreadsView.css';

const ThreadsView = () => {
  const [chats, setChats] = useState([]);
  const [expandedApp, setExpandedApp] = useState(null);
  const [messageCounts, setMessageCounts] = useState({});
  const [newMessage, setNewMessage] = useState('');
  const [isSending, setIsSending] = useState(false);

  useEffect(() => {
    fetchChats();
  }, []);

  const fetchChats = () => {
    axios.get('/api/assistants_chat')
      .then(res => {
        const data = res.data || [];
        setChats(data);

        const counts = {};
        data.forEach(chat => {
          const appId = parseInt(chat.application);
          if (!counts[appId]) counts[appId] = 0;
          counts[appId]++;
        });
        setMessageCounts(counts);
      })
      .catch(err => console.error('Error fetching chats:', err));
  };

  const groupedByApp = chats.reduce((acc, chat) => {
    const key = chat.application || 'Unknown';
    if (!acc[key]) acc[key] = [];
    acc[key].push(chat);
    return acc;
  }, {});

  const handleSendMessage = async () => {
    if (!newMessage.trim()) return;
    setIsSending(true);

    const payload = {
      applicationId: expandedApp,
      emailBody: newMessage
    };

    console.log('Sending message:', payload);

    try {
      await axios.post('/api/tool', payload);
      setNewMessage('');
      fetchChats(); // Refresh chat list
    } catch (err) {
      console.error('Failed to send message:', err);
      alert('Failed to send message');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="threads-container">
      <h2>Assistant Threads by App ID</h2>

      <div className="thread-grid">
        {Object.entries(groupedByApp).map(([appId, threads], index) => (
          <div
            key={index}
            className={`thread-card ${expandedApp === appId ? 'selected' : ''}`}
            onClick={() => setExpandedApp(expandedApp === appId ? null : appId)}
          >
            <h4>App ID: {appId}</h4>
            <p className="count-tag">Messages: {messageCounts[appId] || 0}</p>
          </div>
        ))}
      </div>

      {expandedApp && (
        <div className="thread-details">
          <h3>Threads for App ID: {expandedApp}</h3>

          {/* Message input */}
          <div className="message-input-area">
            <textarea
              placeholder="Type your message here..."
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              rows={3}
              style={{ width: '100%', marginBottom: '8px' }}
            />
            <button onClick={handleSendMessage} disabled={isSending}>
              {isSending ? 'Sending...' : 'Send Message'}
            </button>
          </div>

          {/* Thread list */}
          {(groupedByApp[expandedApp] || []).map((thread, i) => (
            <div key={i} className="thread-item">
              <p><strong>Message:</strong></p>
              <pre className="json-input">{thread.emailBody}</pre>
              <p><strong>Response:</strong></p>
              <pre className="json-input">{thread.response}</pre>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ThreadsView;
